import React, { Component } from 'react';
import { Button, Form, Icon, Input, message, Tabs } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import {
  queryProjReceiveList,
  queryTagList,
  queryTaskReceiveList,
  queryTaskSearchList,
} from '@api/task';
import { setBackInfo } from '@store/modules/back_info';
import TableTask from './TableTask';

import CardAdvPubSearch from './CardAdvPubSearch';
import CardAdvFinSearch from './CardAdvFinSearch';

const { TabPane } = Tabs;
const { Search } = Input;
const FormItem = Form.Item;

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      pagination: {
        total: 10,
        current: 1,
        PageSize: 10,
      },

      tabKey: '1',
      current: 1,
      condition: '',
      status: 'PUBLISH',

      tagList: [],
      projectList: [],

      pubSearchCondition: {},
      finSearchCondition: {},

      isLoading: false,
      isAdvSearch: false,
      advPubSearchVisible: false,
      advFinSearchVisible: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { backInfo } = this.props;
    this.getTagList();
    this.getProjReceiveList();
    if (backInfo.path === this.props.location.pathname) {
      this.setState(
        {
          status: backInfo.status,
          tabKey: backInfo.tabKey,
          current: backInfo.current,
          condition: backInfo.condition,
          pagination: backInfo.pagination,
          isAdvSearch: backInfo.isAdvSearch,
          pubSearchCondition: backInfo.pubSearchCondition,
          finSearchCondition: backInfo.finSearchCondition,
          advPubSearchVisible: backInfo.advPubSearchVisible,
          advFinSearchVisible: backInfo.advFinSearchVisible,
        },
        () => {
          backInfo.isAdvSearch ? this.advSearchData() : this.loadData();
        },
      );
    } else {
      this.loadData();
    }
  }

  componentWillUnmount() {
    const {
      status,
      tabKey,
      current,
      condition,
      pagination,
      isAdvSearch,
      pubSearchCondition,
      finSearchCondition,
      advPubSearchVisible,
      advFinSearchVisible,
    } = this.state;
    const params = {
      path: this.props.location.pathname,
      status,
      tabKey,
      current,
      condition,
      pagination,
      isAdvSearch,
      pubSearchCondition,
      finSearchCondition,
      advPubSearchVisible,
      advFinSearchVisible,
    };
    this.props.dispatch(setBackInfo(params));
  }

  // 加载数据
  loadData = () => {
    const { status, current, condition } = this.state;
    const limit = 10;
    this.setState({
      isLoading: true,
    });
    queryTaskReceiveList({
      status,
      start: current,
      limit,
      name: condition,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          list: res.data,
          pagination: {
            total: res.totalSize,
            current,
            pageSize: 10,
          },
          isAdvSearch: false,
        });
      } else {
        message.error(res.message);
      }
      this.setState({
        isLoading: false,
      });
    });
  };

  // 高级搜索的接口
  advSearchData = () => {
    const { status, current, pubSearchCondition, finSearchCondition } = this.state;
    const limit = 10;
    this.setState({
      isLoading: true,
    });
    let searchCondition = {};
    status === 'PUBLISH' && (searchCondition = pubSearchCondition);
    status === 'FINISH' && (searchCondition = finSearchCondition);
    queryTaskSearchList({
      status,
      start: current,
      limit,
      ...searchCondition,
      endDate: searchCondition.endDate ? moment(searchCondition.endDate).format('YYYY-MM-DD') : '',
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          list: res.data,
          pagination: {
            total: res.totalSize,
            current,
            pageSize: 10,
          },
          isAdvSearch: true,
        });
      } else {
        message.error(res.message);
      }
      this.setState({
        isLoading: false,
      });
    });
  };

  /** ------------------------------------------------搜索及高级搜索start------------------------------------------------------------------------*/

  // 高级搜索会用到的标签tag列表
  getTagList = () => {
    queryTagList().then(res => {
      if (res.statusCode === 200) {
        res.data.unshift({
          uuid: 'all',
          name: '全部',
        });
        this.setState({
          tagList: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 高级搜索会用到的标签tag列表收到的项目
  getProjReceiveList = () => {
    queryProjReceiveList({}).then(res => {
      if (res.statusCode === 200) {
        res.data.unshift({
          uuid: 'all',
          name: '全部',
        });
        this.setState({
          projectList: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 普通搜索
  changeCondition = e => {
    this.setState({
      condition: e.target.value,
    });
  };

  handleSubmit = () => {
    this.setState({ current: 1 }, () => {
      this.loadData();
    });
  };

  // 高级搜索
  showAdvancedSearch = e => {
    e.preventDefault();
    const { status, advPubSearchVisible, advFinSearchVisible } = this.state;
    if (status === 'PUBLISH') {
      this.setState({
        advPubSearchVisible: !advPubSearchVisible,
      });
    } else if (status === 'FINISH') {
      this.setState({
        advFinSearchVisible: !advFinSearchVisible,
      });
    }
  };

  handleOk = params => {
    const { status } = this.state;
    if (status === 'PUBLISH') {
      this.setState(
        {
          current: 1,
          pubSearchCondition: params,
        },
        () => {
          this.advSearchData();
        },
      );
    } else if (status === 'FINISH') {
      this.setState(
        {
          current: 1,
          finSearchCondition: params,
        },
        () => {
          this.advSearchData();
        },
      );
    }
  };

  /** -----------------------------------------------搜索及高级搜索end------------------------------------------------------------------------*/

  // tab栏切换
  changeTabs = key => {
    const { pubSearchCondition, finSearchCondition } = this.state;
    switch (key) {
      case '1':
        this.setState(
          {
            status: 'PUBLISH',
            tabKey: '1',
            current: 1,
          },
          () => {
            let flag = false;
            Object.keys(pubSearchCondition).forEach(objectKey => {
              flag = !!pubSearchCondition[objectKey];
            });
            flag ? this.advSearchData() : this.loadData();
          },
        );
        break;
      case '2':
        this.setState(
          {
            status: 'FINISH',
            tabKey: '2',
            current: 1,
          },
          () => {
            let flag = false;
            Object.keys(finSearchCondition).forEach(objectKey => {
              flag = !!finSearchCondition[objectKey];
            });
            flag ? this.advSearchData() : this.loadData();
          },
        );
        break;
      default:
        break;
    }
  };

  // 列表改变
  changeTable = pagination => {
    const { isAdvSearch } = this.state;
    this.setState({ current: pagination.current }, () => {
      isAdvSearch ? this.advSearchData() : this.loadData();
    });
  };

  // 搜索栏
  renderSearchForm = () => {
    const { status, condition, advPubSearchVisible, advFinSearchVisible } = this.state;
    return (
      <Form
        style={{
          position: 'absolute',
          right: '10px',
          top: '0',
          display: 'flex',
          zIndex: 100,
        }}
      >
        <FormItem>
          <Search
            value={condition}
            placeholder="请输入任务名称"
            onSearch={this.handleSubmit}
            onChange={this.changeCondition}
          />
        </FormItem>
        <FormItem style={{ marginLeft: '10px' }}>
          <Button onClick={this.showAdvancedSearch}>
            高级搜索
            <span style={{ fontSize: '10px', paddingLeft: '10px' }}>
              {(status === 'PUBLISH' && advPubSearchVisible) ||
              (status === 'FINISH' && advFinSearchVisible) ? (
                <Icon type="up" />
              ) : (
                <Icon type="down" />
              )}
            </span>
          </Button>
        </FormItem>
      </Form>
    );
  };

  render() {
    const {
      list,
      tabKey,
      isLoading,
      pagination,
      status,
      tagList,
      projectList,
      pubSearchCondition,
      finSearchCondition,
      advPubSearchVisible,
      advFinSearchVisible,
    } = this.state;
    return (
      <div style={{ position: 'relative' }}>
        {this.renderSearchForm()}
        <Tabs defaultActiveKey="1" activeKey={tabKey} onChange={this.changeTabs}>
          <TabPane tab="发布中" key="1">
            <CardAdvPubSearch
              status={status}
              data={pubSearchCondition}
              tagList={tagList}
              projectList={projectList}
              handleOk={this.handleOk}
              style={{
                display: `${advPubSearchVisible ? 'block' : 'none'}`,
              }}
            />
            <TableTask
              data={list}
              type="receive"
              isLoading={isLoading}
              pagination={pagination}
              loadData={this.loadData}
              onChange={this.changeTable}
              {...this.props}
            />
          </TabPane>
          <TabPane tab="已结束" key="2">
            <CardAdvFinSearch
              status={status}
              data={finSearchCondition}
              tagList={tagList}
              projectList={projectList}
              handleOk={this.handleOk}
              style={{
                display: `${advFinSearchVisible ? 'block' : 'none'}`,
              }}
            />
            <TableTask
              data={list}
              type="receive"
              type2="finish"
              isLoading={isLoading}
              pagination={pagination}
              loadData={this.loadData}
              onChange={this.changeTable}
              {...this.props}
            />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create()(Page));



// WEBPACK FOOTER //
// ./src/components/task/spTask/PageReceive.js